export enum MetricState {
  Initializing = 'INITIALIZING',
  DataGathering = 'DATA_GATHERING',
  Recalculating = 'RECALCULATING',
  Ready = 'READY',
  Failed = 'FAILED'
}

export type MetricPointState = 'real' | 'estimated' | 'partial'

export interface MetricValue {
  section: string | null
  numerator: number
  denominator: number
  xValue: string
  yValue: number
  pointState?: MetricPointState
}

/* One product instance from the metric-scoped compatible-products route; the platform has
 * already applied the metric's supported products, the instance's Connector Domain, and its
 * lifecycle state. `instance_name` is the key the CPI details page filters its source lists by. */
export interface CompatibleProduct {
  instance_name: string
  slug: string
  display_name: string
  connector_domain?: string | null
}

export interface QueryMetricLatestValueRequest {
  section?: string | null
  instance_names?: string[]
}

export interface MetricDataResponse {
  status: MetricState
  zoneColor?: 'red' | 'green' | null
  sla?: number | null
  recentPoint?: MetricValue | null
  lastMonthChange?: number | null
  values?: MetricValue[] | null
}
